import React, { useEffect, useState } from "react";
import { enablePush, disablePush, getPushStatus } from "../lib/push";
import { toast } from "sonner";
import { BellRing, BellOff } from "lucide-react";

export default function PushToggle() {
    const [status, setStatus] = useState("checking");
    const [busy, setBusy] = useState(false);

    const refresh = async () => setStatus(await getPushStatus());

    useEffect(() => { refresh(); }, []);

    if (status === "unsupported") return null;
    const on = status === "subscribed";

    const toggle = async () => {
        setBusy(true);
        try {
            if (on) {
                await disablePush();
                toast.success("Push disabled");
            } else {
                await enablePush();
                toast.success("Push enabled — you'll get notified even when the tab is closed");
            }
            await refresh();
        } catch (e) {
            toast.error(e.message || "Push toggle failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            onClick={toggle}
            disabled={busy}
            className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-lg brut-inset text-sm font-bold ${on ? "bg-[#FFE55C]" : "bg-white"}`}
            data-testid="push-toggle"
            aria-label={on ? "Disable push" : "Enable push"}
        >
            {on ? <BellRing className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
            {on ? "Push on" : "Enable push"}
        </button>
    );
}
